<template lang="pug">
div(class="")
    hr(class="before-32")
    div(class="insety-16")
        ib-button-submit(class="xl scanner_submit accent insetx-64" :disabled="disabled") {{ $t('view_results') }}
        input(class="fg-accent reset_filter pointer", type="reset", :value="$t('reset_filters')", @click.prevent="resetFilter")
</template>

<script>
    export default {
        name: 'SubmitForm',

        props: ['disabled'],

        data() {
           return {
           }
        },
        methods: {
            resetFilter() {
                this.$emit('onReset');
            }
        },
 }
</script>

<style lang="less">
.reset_filter {
    background: none;
    border: none;
    &:focus {
        outline: none;
    }
}
</style>
